import { z } from 'zod';


export const positionFormBaseSchema = z.object({
  code: z
    .string()
    .min(1, 'organization:validation.positionCodeRequired')
    .max(50, 'organization:validation.positionCodeMaxLength'),

  name: z
    .string()
    .min(1, 'organization:validation.positionNameRequired')
    .max(100, 'organization:validation.positionNameMaxLength'),

  description: z
    .string()
    .min(1, 'organization:validation.positionDescriptionRequired')
    .max(8000, 'organization:validation.positionDescriptionMaxLength'),

  areaId: z.union([
    z.coerce
      .number({
        invalid_type_error: 'organization:validation.positionAreaInvalid',
      })
      .int('organization:validation.positionAreaInvalid')
      .positive('organization:validation.positionAreaInvalid'),
    z.null(),
  ]),
});

export const createPositionSchema = positionFormBaseSchema.refine(
  (data) => data.areaId !== null,
  {
    message: 'organization:validation.positionAreaRequired',
    path: ['areaId'],
  },
);

export type PositionFormData = z.infer<typeof positionFormBaseSchema>;
export type CreatePositionFormData = PositionFormData;